module.exports = __webpack_public_path__ + "img/windows-1.e3aa3f31.png";